export default class ChapterConversationEvent {
    constructor(type, dialogId) {
        this._type = type;
        this._dialogId = dialogId;
    }

    get type() {
        return this._type;
    }

    get dialogId() {
        return this._dialogId;
    }
}

ChapterConversationEvent.AVAILABLE = "ChapterConversationEvent.AVAILABLE";
ChapterConversationEvent.COMPLETED = "ChapterConversationEvent.COMPLETED";